import { render, staticRenderFns } from "./survey-add-another.vue?vue&type=template&id=2d6f6020&scoped=true&"
import script from "./survey-add-another.vue?vue&type=script&lang=js&"
export * from "./survey-add-another.vue?vue&type=script&lang=js&"
import style0 from "./survey-add-another.vue?vue&type=style&index=0&id=2d6f6020&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6f6020",
  null
  
)

component.options.__file = "survey-add-another.vue"
export default component.exports